import type { Identity, IdentityPersonType } from "@/screen/Identities/Interfaces/IdentitiesMainScreenInterfaces";

/** Pestañas de Gestión de Intervinientes, una por tipología. */
export interface PersonTypeTab
{
    key: IdentityPersonType;
    title: string;
}

export const PersonTypeTabs: readonly PersonTypeTab[] =
[
    { key: "NaturalPerson", title: "Personas físicas" },
    { key: "LegalEntity", title: "Empresas" },
    { key: "LegalRepresentative", title: "Representantes legales" },
];

/** Sin tipología (backend anterior) el interviniente es una persona física. */
export function getIdentityPersonType(identity: Identity): IdentityPersonType
{
    return identity.personType ?? "NaturalPerson";
}

/**
 * Las pestañas solo se enseñan si el usuario tiene alguna empresa o representante: con solo personas físicas el
 * listado se queda como estaba. Se enseñan todas para que se vea dónde aparecerá cada tipo.
 */
export function shouldShowPersonTypeTabs(identities: Identity[]): boolean
{
    return identities.some((identity) => getIdentityPersonType(identity) !== "NaturalPerson");
}

export function filterByPersonType(identities: Identity[], personType: IdentityPersonType, showTabs: boolean): Identity[]
{
    if(!showTabs)
    {
        return identities;
    }

    return identities.filter((identity) => getIdentityPersonType(identity) === personType);
}

export function countByPersonType(identities: Identity[], personType: IdentityPersonType): number
{
    return identities.filter((identity) => getIdentityPersonType(identity) === personType).length;
}
